import React from "react";

/** One headline number with its label and a short explanation. */
export function Metric({ icon: Icon, label, value, hint, tone }) {
  return (
    <div className={`pl-metric pl-metric--${tone || "accent"}`}>
      <div className="pl-metric-head">
        <span className="pl-metric-icon">
          <Icon aria-hidden="true" />
        </span>
        <span className="pl-metric-label">{label}</span>
      </div>
      <div className="pl-metric-value">{value}</div>
      {hint ? <div className="pl-metric-hint">{hint}</div> : null}
    </div>
  );
}
